import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'

const POINT_RADIUS = 4

interface LegendItemProps {
  label: React.ReactNode
  color: string
  isLoading?: boolean
}

export const LegendItem: FC<LegendItemProps> = ({ color, isLoading = false, label }) => (
  <Box display='flex' flexDirection='row' alignItems='center' flexBasis={0.5} flexGrow={1}>
    {!isLoading && (
      <svg width={`${POINT_RADIUS * 2}`} height={`${POINT_RADIUS * 2}`}>
        <circle cx={POINT_RADIUS} cy={POINT_RADIUS} r={POINT_RADIUS} fill={color} />
      </svg>
    )}
    <span className='text-secondary ml2 flex-grow-1'>{label}</span>
  </Box>
)

export default LegendItem
